import {CREATEJS_UTILITIES_LOGGER} from "../../../../../index";
//import {getLogger} from "@goodgamestudios/logger";
import EventDispatcher = createjs.EventDispatcher;

//const logger = getLogger(CREATEJS_UTILITIES_LOGGER);
export class LoaderInfo extends EventDispatcher {
    constructor() {
        super();
        // TODO figure out why just importing it crashes the test...
      //  LOG: '[DEBUG Fri, 26 May 2017 10:20:55 GMT - DisplayObjectTest] ', function LoaderInfo() { ... }  without import of logger and createjs constant
      //  LOG: '[DEBUG Fri, 26 May 2017 10:20:55 GMT - DisplayObjectTest] ', undefined as soon as we import it..
      //  console.log(CREATEJS_UTILITIES_LOGGER);
    }

    public get content(): any {
        //logger.debug("LoaderInfo.content   not implemented yet");
        return new Object();
    }

    public get url(): string {
        // logger.debug("LoaderInfo.url   not implemented yet");
        return window.location.origin;
    }

    public get parameters(): any {
        // logger.debug("LoaderInfo.parameters   not implemented yet");
        return [];
    }
}